import { render, staticRenderFns } from "./update-picklist.vue?vue&type=template&id=124eeb46"
import script from "./update-picklist.vue?vue&type=script&lang=js"
export * from "./update-picklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports